module.exports = __webpack_public_path__ + "img/dice.89cc9385.svg";